
import { useContext, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { ComparisonContext } from "../../../../config/context/comparisonContext";
import { useSearchParams } from "react-router-dom";
import HTTP from "../../../../config/axios";

const CompareOverview = () => {
    const [searchParams] = useSearchParams();
    const firstCarId = searchParams.get('firstCar');
    const secondCarId = searchParams.get('secondCar');
    const thirdCarId = searchParams.get('thirdCar');
    const fourthCarId = searchParams.get('fourthCar');

    const { compareDetails, setCompareDetails } = useContext(ComparisonContext);
    const firstCarData = compareDetails.first || {}
    const secondCarData = compareDetails.second || {}
    const thirdCarData = compareDetails.third || {}
    const fourthCarData = compareDetails.fourth || {}


    
    // useEffect(() => {
    //     console.log("compareDetails =============", compareDetails);
        
    // },[compareDetails])

    const firstCarSpecs = firstCarData.specs || {}
    const secondCarSpecs = secondCarData.specs || {}
    const thirdCarSpecs = thirdCarData.specs || {}
    const fourthCarSpecs = fourthCarData.specs || {}


    const textColor = (position:string, spec: string ) => {
        const currentSpecValue = Number(compareDetails?.[position]?.['specs']?.[spec]?.['value'])|| 0
        const firstSpecValue = Number(compareDetails?.['first']?.['specs']?.[spec]?.['value'])|| 0
        const secondSpecValue = Number(compareDetails?.['second']?.['specs']?.[spec]?.['value'])|| 0
        const thirdSpecValue = Number(compareDetails?.['third']?.['specs']?.[spec]?.['value'])|| 0
        const fourthSpecValue = Number(compareDetails?.['fourth']?.['specs']?.[spec]?.['value'])|| 0


        if(currentSpecValue >= firstSpecValue && currentSpecValue >= secondSpecValue &&
            currentSpecValue >= thirdSpecValue && currentSpecValue >= fourthSpecValue){
                return 'text-start text-success is-description mt-2'
            }else{
                return 'text-start text-dark is-description mt-2'
            }
    }
    

    return (
        <div className="App">
            <Row className="border-bottom px-0 text-break" style={{ wordBreak: 'break-all' }}>
                <Col md={2} className=" comparsion-img-out text-start border-end">
                    <p className="text-start mt-2">Fuel type</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className="text-start text-dark is-description mt-2">{firstCarData.fuel || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className="text-start text-dark is-description mt-2">{secondCarData.fuel || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className="text-start text-dark is-description mt-2">{thirdCarData.fuel || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start ">
                    <p className="text-start text-dark is-description mt-2">{fourthCarData.fuel || "-"}</p>
                </Col>
            </Row>
            <Row className="border-bottom px-0 text-break">
                <Col md={2} className=" comparsion-img-out text-start border-end">
                    <p className="text-start mt-2">Mileage-City (kmpl)</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className={ textColor('first','mileage-(arai)')} >{firstCarSpecs['mileage-(arai)']?.value || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className={ textColor('second','mileage-(arai)')}>{secondCarSpecs['mileage-(arai)']?.value || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className={ textColor('third','mileage-(arai)')}>{thirdCarSpecs['mileage-(arai)']?.value || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start ">
                    <p className={ textColor('fourth','mileage-(arai)')}>{fourthCarSpecs['mileage-(arai)']?.value || "-"}</p>
                </Col>
            </Row>
            <Row className="border-bottom px-0 text-break">
                <Col md={2} className=" comparsion-img-out text-start border-end">
                    <p className="text-start mt-2">Fuel Capacity (litres)</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className={ textColor('first','fuel-tank-capacity')}>{firstCarSpecs['fuel-tank-capacity']?.value || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className={ textColor('second','fuel-tank-capacity')}>{secondCarSpecs['fuel-tank-capacity']?.value || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className={ textColor('third','fuel-tank-capacity')}>{thirdCarSpecs['fuel-tank-capacity']?.value || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start ">
                    <p className={ textColor('fourth','fuel-tank-capacity')}>{fourthCarSpecs['fuel-tank-capacity']?.value || "-"}</p>
                </Col>
            </Row>
            <Row className="border-bottom px-0 text-break">
                <Col md={2} className=" comparsion-img-out text-start border-end">
                    <p className="text-start mt-2">Seating Capacity</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className={ textColor('first','seating-capacity')}>{firstCarSpecs['seating-capacity']?.value || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className={ textColor('second','seating-capacity')}>{secondCarSpecs['seating-capacity']?.value || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className={ textColor('third','seating-capacity')}>{thirdCarSpecs['seating-capacity']?.value || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start ">
                    <p className={ textColor('fourth','seating-capacity')}>{fourthCarSpecs['seating-capacity']?.value || "-"}</p>
                </Col>
            </Row>
            <Row className="border-bottom px-0 text-break">
                <Col md={2} className=" comparsion-img-out text-start border-end">
                    <p className="text-start mt-2">Transmission Type</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className="text-start text-dark is-description mt-2">{firstCarData.transmission || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className="text-start text-dark is-description mt-2">{secondCarData.transmission || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className="text-start text-dark is-description mt-2">{thirdCarData.transmission || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start ">
                    <p className="text-start text-dark is-description mt-2">{fourthCarData.transmission || "-"}</p>
                </Col>
            </Row>
            <Row className="border-bottom px-0 text-break">
                <Col md={2} className=" comparsion-img-out text-start border-end">
                    <p className="text-start mt-2">Engine Displacement(CC)</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className={ textColor('first','displacement')}>{firstCarSpecs['displacement']?.value || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className={ textColor('second','displacement')}>{secondCarSpecs['displacement']?.value || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start border-end">
                    <p className={ textColor('third','displacement')}>{thirdCarSpecs['displacement']?.value || "-"}</p>
                </Col>
                <Col md={2} className="comparsion-img-out text-start ">
                    <p className={ textColor('fourth','displacement')}>{fourthCarSpecs['displacement']?.value || "-"}</p>
                </Col>
            </Row>
        </div >
    );
};

export default CompareOverview;
